import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'react-query';

import { fetchEventTickets } from '../api/fetchEventTickets';

export function useEventTickets(eventId: number | undefined, enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.reports.tickets(eventId ?? 0),
        queryFn: () => fetchEventTickets(eventId!),
        enabled: enabled && Boolean(eventId),
    });
}
